import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { Box, Drawer, Grid, TextField, Button, Divider, Typography } from '@mui/material';

// Utils
import messages from '../../static/messages';

// Services
import resourceServices from '../../services/resourceServices';

// Styles
import { button } from '../../static/theme-styles';

// External variables
const required_fields = ['name', 'description'];

const AppointmentMediaDrawer = (props) => {
  const { currentItem, setCurrentItem, addNewMedia, updateMedia } = props;
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});

  // Action functions
  const resetErrors = () => {
    setErrors({});
    required_fields.forEach((el) =>
      setErrors((prevState) => ({
        ...prevState,
        [el]: false,
      })),
    );
  };

  const resetFile = () => setFile(null);

  // Handler functions
  const handleClose = () => props.onCloseDrawer(resetErrors);

  const handleChange = (e) => {
    const key = e.target.name;
    const val = e.target.value;

    setCurrentItem((prevState) => ({
      ...prevState,
      [key]: val,
      isEdited: true,
    }));
  };

  const handleValidate = () => {
    resetErrors();

    required_fields.forEach((field) => {
      const el = currentItem[field];
      if (el === '' || el === null) {
        setErrors((prevState) => ({
          ...prevState,
          [field]: true,
        }));
      } else {
        setErrors((prevState) => ({
          ...prevState,
          [field]: false,
        }));
      }
    });
  };

  // Async functions
  const onAddNewFile = async (e) => {
    const file = e.target.files[0];
    try {
      const response = await resourceServices.upload(file, 'appointment-media');

      if (response.status === 201) {
        setCurrentItem((prevState) => ({
          ...prevState,
          resource: {
            id: response.data.id,
          },
          isEdited: true,
        }));
        setFile(response.data.url);
      }
    } catch (error) {
      toast.error(messages.errors.error_try_again);
      console.log(error);
    }
  };

  // Hooks
  useEffect(() => {
    resetErrors();
  }, []);

  useEffect(() => {
    if (currentItem?.isEdited) {
      !Object.values(errors).includes(true) && (props.isNewItem ? addNewMedia(resetFile) : updateMedia());
    }
  }, [errors]);

  return (
    <Drawer anchor="right" open={props.drawer} onClose={handleClose}>
      <Box>
        {props.currentItem && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box>
                <Typography variant="h4" gutterBottom>
                  {props.isNewItem ? 'Add New Media' : 'Update Media'}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                name="name"
                label="Name"
                defaultValue={currentItem.name}
                fullWidth
                onChange={handleChange}
                error={errors.name}
                helperText={errors.name && messages.errors.required_field}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                required
                name="description"
                label="Description"
                multiline
                rows={4}
                defaultValue={currentItem.description}
                fullWidth
                onChange={handleChange}
                error={errors.description}
                helperText={errors.description && messages.errors.required_field}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Resources
              </Typography>

              {!props.isNewItem && (
                <a href={currentItem.resource?.url} style={{ marginBottom: 16 }} target="_blank" rel="noReferrer">
                  View File
                </a>
              )}

              {file && <img src={file} style={{ width: 300, height: 'auto ' }} />}

              {/* {file && (
                <a href={file} style={{ marginBottom: 16 }} target="_blank" rel="noReferrer">
                  View File
                </a>
              )} */}

              {props.isNewItem && !file && (
                <Button variant="contained" component="label" sx={{ ...button('secondary'), mt: 2 }}>
                  Upload
                  <input hidden accept="image/*, .heic, .pdf, application/pdf" multiple type="file" onChange={onAddNewFile} />
                </Button>
              )}
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                sx={{ ...button('primary', 'secondary'), mr: 3 }}
                disabled={!currentItem.isEdited}
                onClick={handleValidate}
              >
                {props.isNewItem ? 'Add New Media' : 'Update Media'}
              </Button>

              <Button variant="contained" onClick={handleClose} sx={button('secondary')}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Drawer>
  );
};

export default AppointmentMediaDrawer;
